import { toEDNString, toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { CodeBlock, CodeBlockNoteBlock } from "../types/codeBlock";

export const getCodeBlock: (config: {
  appId: string;
  codeBlockId: string;
}) => Promise<CodeBlock> = async ({ appId, codeBlockId }) => {
  const ednString = toEDNString({
    map: [
      ["app-id", appId],
      ["code-block-id", codeBlockId],
    ],
  });
  const query = `
    (datastore Qo.Public.Api.CodeBlock "omega/query-omega/public/code-block")
    (Qo.Public.Api.CodeBlock/get-code-block ${ednString} Response)
    (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const setCodeBlockCode: (config: {
  appId: string;
  codeBlockId: string;
  code: string;
}) => Promise<CodeBlockNoteBlock> = async ({ appId, codeBlockId, code }) => {
  const ednString = toEDNString({
    map: [
      ["app-id", appId],
      ["code-block-id", codeBlockId],
      ["code", code],
    ],
  });
  const query = `
    (datastore Qo.Public.Api.CodeBlock "omega/query-omega/public/code-block")
    (Qo.Public.Api.CodeBlock/set-code-block-code ${ednString} Response)
    (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const runCodeBlock: (config: {
  appId: string;
  codeBlockId: string;
}) => Promise<CodeBlock> = async ({ appId, codeBlockId }) => {
  const ednString = toEDNString({
    map: [
      ["app-id", appId],
      ["code-block-id", codeBlockId],
    ],
  });
  const query = `
    (datastore Qo.Public.Api.CodeBlock "omega/query-omega/public/code-block")
    (Qo.Public.Api.CodeBlock/run-code-block ${ednString} Response)
    (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const deleteCodeBlock: (config: {
  appId: string;
  codeBlockId: string;
}) => Promise<CodeBlockNoteBlock> = async ({ appId, codeBlockId }) => {
  const ednString = toEDNString({
    map: [
      ["app-id", appId],
      ["code-block-id", codeBlockId],
    ],
  });
  const query = `
    (datastore Qo.Public.Api.CodeBlock "omega/query-omega/public/code-block")
    (Qo.Public.Api.CodeBlock/delete-code-block ${ednString} Response)
    (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const createCodeBlock: (block: CodeBlock) => Promise<CodeBlock> = async (
  block
) => {
  const ednString = toEDNStringFromSimpleObject(block as any, {
    keysAs: "string",
  });
  const query = `
    (datastore Qo.Public.Api.CodeBlock "omega/query-omega/public/code-block")
    (Qo.Public.Api.CodeBlock/create-code-block ${ednString} Response)
    (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
